import {
  DESIGN_CATALOGUE_TEMPLATES,
  type DesignCatalogueTemplateId,
} from '../../lib/designTemplates';

type Props = {
  value: DesignCatalogueTemplateId | string;
  onChange: (id: DesignCatalogueTemplateId) => void;
};

/** Tiny schematic matching each template's real layout (not just colour). */
function LayoutSketch({ id }: { id: DesignCatalogueTemplateId }) {
  switch (id) {
    case 'promo_grid_clean':
      return (
        <span className="design-template-gallery__sketch design-template-gallery__sketch--split" aria-hidden>
          <span className="design-template-gallery__sketch-pane" />
          <span className="design-template-gallery__sketch-rows">
            <span />
            <span />
            <span />
          </span>
        </span>
      );
    case 'promo_grid_new_product':
      return (
        <span className="design-template-gallery__sketch design-template-gallery__sketch--feature" aria-hidden>
          <span className="design-template-gallery__sketch-hero" />
          <span className="design-template-gallery__sketch-mini">
            <span />
            <span />
          </span>
        </span>
      );
    case 'promo_grid_festive':
      return (
        <span className="design-template-gallery__sketch design-template-gallery__sketch--banner" aria-hidden>
          <span className="design-template-gallery__sketch-band" />
          <span className="design-template-gallery__sketch-grid2">
            <span />
            <span />
            <span />
            <span />
          </span>
        </span>
      );
    case 'promo_grid_year_end':
      return (
        <span className="design-template-gallery__sketch design-template-gallery__sketch--banner" aria-hidden>
          <span className="design-template-gallery__sketch-band" />
          <span className="design-template-gallery__sketch-grid2">
            <span />
            <span />
            <span />
            <span />
          </span>
        </span>
      );
    case 'promo_grid_giveaway':
      return (
        <span className="design-template-gallery__sketch design-template-gallery__sketch--tickets" aria-hidden>
          <span className="design-template-gallery__sketch-stamp" />
          <span />
          <span />
          <span />
        </span>
      );
    default:
      return (
        <span className="design-template-gallery__sketch design-template-gallery__sketch--grid2" aria-hidden>
          {Array.from({ length: 4 }, (_, i) => (
            <span key={i} />
          ))}
        </span>
      );
  }
}

export function DesignTemplateGallery({ value, onChange }: Props) {
  return (
    <div className="design-template-gallery" role="listbox" aria-label="Catalogue template">
      {DESIGN_CATALOGUE_TEMPLATES.map((tmpl) => {
        const selected = tmpl.id === value;
        return (
          <button
            key={tmpl.id}
            type="button"
            role="option"
            aria-selected={selected}
            className={`design-template-gallery__card${selected ? ' is-selected' : ''}`}
            title={tmpl.description}
            onClick={() => onChange(tmpl.id)}
          >
            <span
              className="design-template-gallery__swatch"
              style={{
                background: `linear-gradient(145deg, ${tmpl.swatchFrom}, ${tmpl.swatchTo})`,
              }}
            >
              <LayoutSketch id={tmpl.id} />
            </span>
            <span className="design-template-gallery__meta">
              <strong>{tmpl.label}</strong>
              <span>{tmpl.layoutHint}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
